import { BOGeneralValues } from "./BOGeneralValues.model";

export class BORelatedMedicDiagnostic extends BOGeneralValues{
    id:number;
    diseaseCode:string;
    orphanDisease:string;
    diseaseName:string;
}